import { useBillingAcceptanceAdvancedQuery } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useAcceptanceAdvanced = (companyId: string) => {
  const { data, loading, error, startPolling, stopPolling } = useBillingAcceptanceAdvancedQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    variables: {
      companyId,
    },
  });

  const acceptanceAdvanced = data?.acceptanceAdvancedQuery;

  return {
    error,
    loading,
    acceptanceAdvanced,
    startPolling,
    stopPolling,
  };
};

export default useAcceptanceAdvanced;
